import { AccordionWidget } from '@website-builder/widgets/accordion/accordion-widget';
import { BaseWidget } from '@website-builder/widgets/base/base-widget';
import { GalleryWidget } from '@website-builder/widgets/gallery/gallery-widget';
import { HeadlineWidget } from '@website-builder/widgets/headline/headline-widget';
import { ImageWidget } from '@website-builder/widgets/image/image-widget';
import { TextWidget } from '@website-builder/widgets/text/text-widget';
import { BaseWidgetNormalizer } from '@website-builder/widgets/normalizer/base-widget-normalizer';
import { ButtonWidget } from '@website-builder/widgets/button/button-widget';
import { CountdownWidget } from '@website-builder/widgets/countdown/countdown-widget';
import { DescriptionListWidget } from '@website-builder/widgets/description-list/description-list-widget';
import { DividerWidget } from '@website-builder/widgets/divider/divider-widget';
import { IconWidget } from '@website-builder/widgets/icon/icon-widget';
import { ListWidget } from '@website-builder/widgets/list/list-widget';
import { GoogleMapWidget } from '@website-builder/widgets/google-map/google-map-widget';
import { MenuWidget } from '@website-builder/widgets/menu/menu-widget';
import { NewsletterWidget } from '@website-builder/widgets/newsletter/newsletter-widget';
import { PanelWidget } from '@website-builder/widgets/panel/panel-widget';
import { PopoverWidget } from '@website-builder/widgets/popover/popover-widget';
import { SliderWidget } from '@website-builder/widgets/slider/slider-widget';
import { SlideshowWidget } from '@website-builder/widgets/slidershow/slideshow-widget';
import { SocialWidget } from '@website-builder/widgets/social/social-widget';
import { TableWidget } from '@website-builder/widgets/table/table-widget';
import { TabsWidget } from '@website-builder/widgets/tabs/tabs-widget';
import { ToTopWidget } from '@website-builder/widgets/to-top/to-top-widget';
import { VideoWidget } from '@website-builder/widgets/video/video-widget';
import { BuilderElementType } from '@website-builder/model/domain/builder-element-type.enum';
import { BuilderWidgetType } from '@website-builder/model/state/builder-widget.type';
import { WidgetNormalizerFn } from '@website-builder/widgets/normalizer/model/widget-normalizer-fn.type';

export class WidgetNormalizer {
  static normalizeInPlace(widget: BaseWidget): BaseWidget {
    if (!widget) {
      return widget;
    }

    const normalize = widgetNormalizers[widget.type];

    return normalize ? normalize(widget) : BaseWidgetNormalizer.normalizeInPlace(widget);
  }
}

const widgetNormalizers: Partial<Record<BuilderWidgetType, WidgetNormalizerFn>> = {
  [BuilderElementType.Accordion]: widget => AccordionWidget.normalizeInPlace(widget as AccordionWidget),
  [BuilderElementType.Button]: widget => ButtonWidget.normalizeInPlace(widget as ButtonWidget),
  [BuilderElementType.Countdown]: widget => CountdownWidget.normalizeInPlace(widget as CountdownWidget),
  [BuilderElementType.DescriptionList]: widget =>
    DescriptionListWidget.normalizeInPlace(widget as DescriptionListWidget),
  [BuilderElementType.Divider]: widget => DividerWidget.normalizeInPlace(widget as DividerWidget),
  [BuilderElementType.Gallery]: widget => GalleryWidget.normalizeInPlace(widget as GalleryWidget),
  [BuilderElementType.Headline]: widget => HeadlineWidget.normalizeInPlace(widget as HeadlineWidget),
  [BuilderElementType.Icon]: widget => IconWidget.normalizeInPlace(widget as IconWidget),
  [BuilderElementType.Image]: widget => ImageWidget.normalizeInPlace(widget as ImageWidget),
  [BuilderElementType.List]: widget => ListWidget.normalizeInPlace(widget as ListWidget),
  [BuilderElementType.Map]: widget => GoogleMapWidget.normalizeInPlace(widget as GoogleMapWidget),
  [BuilderElementType.Menu]: widget => MenuWidget.normalizeInPlace(widget as MenuWidget),
  [BuilderElementType.Newsletter]: widget => NewsletterWidget.normalizeInPlace(widget as NewsletterWidget),
  [BuilderElementType.Panel]: widget => PanelWidget.normalizeInPlace(widget as PanelWidget),
  [BuilderElementType.Popover]: widget => PopoverWidget.normalizeInPlace(widget as PopoverWidget),
  [BuilderElementType.Slider]: widget => SliderWidget.normalizeInPlace(widget as SliderWidget),
  [BuilderElementType.Slideshow]: widget => SlideshowWidget.normalizeInPlace(widget as SlideshowWidget),
  [BuilderElementType.Social]: widget => SocialWidget.normalizeInPlace(widget as SocialWidget),
  [BuilderElementType.Table]: widget => TableWidget.normalizeInPlace(widget as TableWidget),
  [BuilderElementType.Tabs]: widget => TabsWidget.normalizeInPlace(widget as TabsWidget),
  [BuilderElementType.Text]: widget => TextWidget.normalizeInPlace(widget as TextWidget),
  [BuilderElementType.ToTop]: widget => ToTopWidget.normalizeInPlace(widget as ToTopWidget),
  [BuilderElementType.Video]: widget => VideoWidget.normalizeInPlace(widget as VideoWidget),
};
